import React, { Component } from "react";
import './contactHome.css';

import { ChangedData } from "../../assets/ChangedData/ChangedData";
import { AllData } from "../../Screens/Home";

// Icons
import edge from "../../assets/Icons/edge-brandsC.png";
import envelope from "../../assets/Icons/envelope-solidC.png";
import locationdC from "../../assets/Icons/locationdC.png";
import phone from "../../assets/Icons/phone-solidC.png";


class ContactHome extends Component{
    constructor(){
        super();

        this.state = {
            rendCards: "" ,
            DataConC: ""
        }

        this.rendCCards = this.rendCCards.bind(this);
        this.fetchAllData = this.fetchAllData.bind(this);

    }

    NotCalled = true;
    componentDidMount(){
        this.fetchAllData();
        
        
        window.addEventListener("scroll" , ()=>{
            let ScrollAniElements = document.querySelectorAll(".ScrollAnimationCont");
            let windowH = window.innerHeight;
            let TopmainBlogHomeContainer = document.querySelector("#ContactCards").getBoundingClientRect().top;
            let BottommainBlogHomeContainer = document.querySelector("#ContactCards").getBoundingClientRect().bottom;


            if (windowH / 1.6 >  TopmainBlogHomeContainer && BottommainBlogHomeContainer > windowH / 1.8 && this.NotCalled === true) {
                this.ScrollAnimation(ScrollAniElements);
                this.NotCalled = false;
            }
        });


        window.addEventListener("DOMContentLoaded" , ()=>{
            setTimeout(() => {
                const ConttTilsAT = document.getElementsByClassName("ConttTilsAT");
                for (let i = 0; i < ConttTilsAT.length; i++) {
                    ConttTilsAT[i].addEventListener("click" ,()=>{
                        setTimeout(() => {
                            this.rendCCards();
                        }, 400);
                    });
                }

                // Ok Button To Add New Card
                document.getElementById("OkAddCardC").addEventListener("click" , ()=>{
                    setTimeout(() => {
                        this.rendCCards();
                        console.log(AllData["ContactD"]);
                    }, 400);
                });
            }, 1200);

        });
    }

    componentWillUnmount(){
        let NotCalled = true;
        window.removeEventListener("scroll" , ()=>{
            let ScrollAniElements = document.querySelectorAll(".ScrollAnimationCont");
            let windowH = window.innerHeight;
            let TopmainBlogHomeContainer = document.querySelector("#ContactCards").getBoundingClientRect().top;
            let BottommainBlogHomeContainer = document.querySelector("#ContactCards").getBoundingClientRect().bottom;

            if (windowH / 1.6 >  TopmainBlogHomeContainer && BottommainBlogHomeContainer > windowH / 1.8 && NotCalled === true) {
                this.ScrollAnimation(ScrollAniElements);
                NotCalled = false;
            }
        });
    }

    async fetchAllData(){
        const allFiles = ["ContactD"];
        const stateKey = ["DataConC"];

        await fetch(`${process.env.PUBLIC_URL}/mydata/`+ allFiles[0] + ".json").then((r) => r.json()).then((data) =>{
            AllData[allFiles[0]] = data;
            
        }).finally( ()=>{
            this.state.DataConC = AllData["ContactD"];
            this.rendCCards();
        });
    }

    WaitTiming = 140;
    ScrollAnimation(elements){
        let index = 0;
        let Elementslength = elements.length;
    
        const Loop = () =>{
            setTimeout(() => {
                if (index < Elementslength) {
                    elements[index].classList.remove("ScrollAnimationCont");
                    index++;
                    Loop();
                }
            }, this.WaitTiming);
        }
        Loop();
    }

    clickToEditAtUi(event){
        var Uitarget = event.target.getAttribute("uitarget");
        document.getElementById(Uitarget).click();
        this.ToolsZu();
    }

    openDropFContainer(){
        const DropFileContainer = document.getElementById("DropFileContainer");
        DropFileContainer.classList.remove("DropFileContainerZu");

        const DropFileBG = document.getElementById("DropFileBG");
        const BodyVisableZu = document.getElementById("BodyVisableZu");

        setTimeout(() => {
            DropFileBG.classList.remove("DropFileBGZu");
        }, 10);

        setTimeout(() => {
            BodyVisableZu.classList.remove("BodyVisableZu");
        }, 300);
    }

    toTextEditFunction(event){
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.id;
    
            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");
    
            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }
    
            textArea.focus();
            textArea.value = Oldtext;
    
            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";

            let indexID = id.substring(6 , id.length);
            id = id.substring(0 , 6);
    

            toTextEdit.addEventListener("focusout" , ()=> {
                if ( textArea.value.length > 0) {
                    let NewValueTextarea = textArea.value
                    toTextEdit.innerHTML = NewValueTextarea;

                    // file name
                    let APIfileName = event.target.getAttribute("data-f");
                    // atribut name
                    let atributname = event.target.id;
                    // get text after chanched
                    let textafter = event.target.innerHTML;

                    if (id != "cadkey" && id != "cadval") {
                        AllData["ContactD"][atributname] = textafter;
                    }
                    if (id == "cadkey") {
                        AllData["ContactD"]["Cards"][indexID]["key"] = textafter;
                    }
                    if (id == "cadval") {
                        AllData["ContactD"]["Cards"][indexID]["value"] = textafter;
                    }

                    if (Oldtext != textafter) {
                        let SaveChangContainer = document.getElementById("SaveChangContainer");
                        SaveChangContainer.style.visibility = "visible";

                        if ( !ChangedData[APIfileName]) {
                            ChangedData[APIfileName] = AllData[APIfileName];
                        }
                    }
                }else{
                    // return old Text
                    toTextEdit.innerHTML = Oldtext;
                }
            });
        
        }
    }

    hoverEditOn(event){
        if (localStorage.getItem("isLogged") == "true") {
            event.target.classList.add("editCursurOnHover");
        }
    }
    hoverEditOut(event){
        let TargetElement = event.target;
        let inn = TargetElement.classList[0];
        let toRemoveElement = document.querySelector("."+inn+" .EditLogoContainer");
        if (toRemoveElement){
            TargetElement.removeChild(toRemoveElement);
        }
    }

    rendCCards(){
        this.state.rendCards = this.state.DataConC.Cards.map( (card , index) => <div className="ContactCard ScrollAnimationCont">
            <div className="ContactCardHeaderContainer  d-flex flex-column justify-content-center align-items-center">
                <div className="ContactCardHeaderLogo  d-flex flex-column justify-content-center align-items-center">
                    <div className="ContactCardHeaderLogo  d-flex flex-column justify-content-center align-items-center" onClick={this.openDropFContainer} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOn} >
                        <img src={card.logo} className="ContactCardHeaderLogoICON"/> 
                    </div>
                </div>
            </div>

            <div className="ContactCardBodyContainer  d-flex flex-column justify-content-center align-items-center">
                <p className="contactCardLable" id={ "cadkey"+index } onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="ContactD"> {card.key} </p>
                { localStorage.getItem("isLogged") == "true" ?  <p className="contactCardInfo" id={ "cadval"+index } onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="ContactD"> {card.value}  </p> :  <a href={card.link}  className="contactCardInfo"> {card.value}  </a>}
            </div>
        </div> );
        this.NotCalled = true;
    }





























    render(){
        return(
            <div>
                <div id="Contact" className="ScreenRouteDiv"></div>
                    <div className="ContactContainer d-flex flex-column justify-content-center align-items-center">
                        <div className="ContactContainerIN">

                            <div className="ContactHeader d-flex flex-column justify-content-center align-items-center">
                                <p className="ContactTitle" id="ContactTitle" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="ContactD"> { this.state.DataConC.ContactTitle } </p>
                                <p className="ContactUderTxt" id="UndContactTitle" onClick={this.toTextEditFunction} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut} data-f="ContactD"> { this.state.DataConC.UndContactTitle } </p>
                            </div>

                            <div className="ContactCards " id="ContactCards">
                                { this.state.rendCards  }
                            </div>


                            <div className="ContactFormContainer d-flex justify-content-between align-items-center">
                                <div className="ContactPhotoContainer">
                                    <img className="ContactPhoto" src={ this.state.DataConC.FormImage } onClick={this.openDropFContainer} onMouseOver={this.hoverEditOn} onMouseLeave={this.hoverEditOut}  alt="me" />
                                </div>

                                <div className="FormOfContact">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="Name" placeholder="Name" />
                                        <label for="floatingLable"> { this.state.DataConC.Iname } </label>
                                    </div>

                                    <div className="form-floating ">
                                        <input type="text" className="form-control" id="Name" placeholder="Email" />
                                        <label for="floatingLable"> { this.state.DataConC.Iemail } </label>
                                    </div>

                                    <div className="form-floating ">
                                        <input type="text" class="form-control" id="Name" placeholder="Subject" />
                                        <label for="floatingLable">{ this.state.DataConC.Isub } </label>
                                    </div>

                                    <div className="form-floating">
                                        <textarea className="form-control MessageContact" placeholder="Leave a Message here" id="floatingTextarea2"></textarea>
                                        <label for="floatingTextarea2 floatingLable">{ this.state.DataConC.Imsg } </label>
                                    </div>

                                    <div className="SendMessageBTN d-flex justify-content-center align-items-center">
                                        <span className="BtnSendTitle">SEND MESSAGE</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
            </div>
        );
    }
}


export default ContactHome;